import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import {InstantPreviousMeetingDialogComponent} from '../../components/instant-previous-meeting-dialog/instant-previous-meeting-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { MediaObserver, MediaChange } from '@angular/flex-layout';
import { Subscription } from 'rxjs';
import {PreviousMeetingHistoryDialogComponent} from '../../components/previous-meeting-history-dialog/previous-meeting-history-dialog.component';
import { InstantMeetingDescriptionComponent } from 'src/app/components/instant-meeting-description/instant-meeting-description.component';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';

@Component({
  selector: 'app-instant-meeting-created',
  templateUrl: './instant-meeting-created.component.html',
  styleUrls: ['./instant-meeting-created.component.css']
})
export class InstantMeetingCreatedComponent implements OnInit, OnDestroy {
  options: any
  today : any
  currentDate : any

  mediaSub!: Subscription;
  deviceXs!: boolean;
  deviceSm!: boolean;
  deviceMd!: boolean;
  deviceLg!: boolean;
  deviceXl!: boolean;
 
  @ViewChild(InstantMeetingDescriptionComponent) insDescpComp !: InstantMeetingDescriptionComponent;

  xl = {
    panelClass: ['animate__animated','animate__slideInRight'],
    position : {
      left : "50%"
    },
    maxWidth: "100%",
    maxHeight: "100vh",
    width : "50%",
    height : "100vh",
    overflow : "hidden"
  }

  lg = {
    panelClass: ['animate__animated','animate__slideInRight'],
    position : {
      left : "50%"
    },
    maxWidth: "100%",
    maxHeight: "100vh",
    width : "50%",
    height : "100vh",
    overflow : "hidden"
  }

  md = {
    panelClass: ['animate__animated','animate__slideInRight'],
    position : {
      left : "30%"
    },
    maxWidth: "100%",
    maxHeight: "100vh",
    width : "50%",
    height : "100vh",
    overflow : "hidden"
  }

  sm = {
    panelClass: ['animate__animated','animate__slideInRight'],
    position : {
      left : "20%"
    },
    width : "calc(100% - 100px)",
    height : "calc(100% - 0px)",
  }

  xs = {
    panelClass: ['animate__animated','animate__slideInRight'],
    position : {
      left : "20%"
    },
    width : "calc(100% - 0px)",
    height : "calc(100% - 0px)",
  }

  constructor(private readonly breakpointObserver: BreakpointObserver,private dialog : MatDialog, public mediaObserver : MediaObserver) { }

  ngOnInit() {
    // this.dialog.open(InstantPreviousMeetingDialogComponent, {
    //   panelClass: ['animate__animated','animate__slideInRight'],
    //   position : {
    //     left : "50%"
    //   },
    //   width : "700px",
    //   height : "700px",
    // })
    this.options = {
      month : 'short',
      day : 'numeric',
      year : 'numeric'
    }
  
    this.today = new Date();
    this.currentDate = this.today.toLocaleDateString("en-US",this.options)
  this.mediaSub = this.breakpointObserver.observe([
    Breakpoints.XSmall,
    Breakpoints.Small,
    Breakpoints.Medium,
    Breakpoints.Large,
    Breakpoints.XLarge
  ]).subscribe(result => {
    const breakpoints = result.breakpoints;

    this.deviceXs = breakpoints[Breakpoints.XSmall] || false;
    this.deviceSm = breakpoints[Breakpoints.Small] || false;
    this.deviceMd = breakpoints[Breakpoints.Medium] || false;
    this.deviceLg = breakpoints[Breakpoints.Large] || false;
    this.deviceXl = breakpoints[Breakpoints.XLarge] || false;
  });
  }

  boolean = true;

  previosMeetingDialog() {
    // this.dialog.open(InstantPreviousMeetingDialogComponent, {
    //   panelClass: ['animate__animated','animate__slideInRight'],
    //   position : {
    //     left : "50%"
    //   },
    //   width : "700px",
    //   height : "700px",
    // })
    if(this.deviceLg){
      this.dialog.open(PreviousMeetingHistoryDialogComponent, this.lg)
    }
    if(this.deviceMd){
      this.dialog.open(PreviousMeetingHistoryDialogComponent, this.md)
    }
    if(this.deviceSm){
      this.dialog.open(PreviousMeetingHistoryDialogComponent, this.sm)
    }
    if(this.deviceXs){
      this.dialog.open(PreviousMeetingHistoryDialogComponent, this.xs)
    }
    if(this.deviceXl){
      this.dialog.open(PreviousMeetingHistoryDialogComponent, this.xl)
    }
  }

  ngOnDestroy(){
    this.mediaSub?.unsubscribe();
    this.insDescpComp.updateRecurFields();
  }

}
